import React from "react";
import { createRoot } from "react-dom/client";
import { NavBar } from "./components/header";
import { snakeToCamelCase } from "design_system/utils/snakeToCamelCase";
import { NavBarProps } from "./components/header/NavBar";
import { ThemeConfig } from "design_system/Theme";

const container = $("#navbar-top").get(0) as HTMLElement;
const {
    patient_app_context = {},
    formatted_phone_call_inbound,
    provider_business_unit_logo,
    provider_name,
} = cedar.serverDataGlobal;
const patientAppContext = snakeToCamelCase(patient_app_context);

const isSuppressed = Object.keys(patientAppContext ?? {}).length === 0;

const navBarProps = {
    formattedPhoneCallInbound: formatted_phone_call_inbound,
    providerBusinessUnitLogoSrc: provider_business_unit_logo,
    providerName: provider_name,
    isSuppressed,
    ...patientAppContext,
} as NavBarProps;

const brandedMomentsEnabled = cedar.serverDataGlobal?.branded_moments_enabled;

const root = createRoot(container);
root.render(
    <ThemeConfig pbuPrimaryBrand={brandedMomentsEnabled ? "pbu-primary-brand" : undefined}>
        <NavBar {...navBarProps} />
    </ThemeConfig>,
);
